import React from 'react';
import type { U3204MissionModelFooterTag } from '../utils/u3204BuildMissionModelFooterLabel';

const tagBaseClass =
  'inline-flex max-w-56 shrink-0 items-center truncate rounded-full px-2.5 py-0.5 text-xs font-medium';

const tagKindClass: Record<U3204MissionModelFooterTag['kind'], string> = {
  provider: 'border border-border bg-muted/80 text-muted-foreground',
  model: 'border border-primary/30 bg-primary/5 text-foreground',
};

interface U3204MissionModelTagProps {
  tag: U3204MissionModelFooterTag;
}

export const U3204MissionModelTag: React.FC<U3204MissionModelTagProps> = ({ tag }) => (
  <span className={`${tagBaseClass} ${tagKindClass[tag.kind]}`} title={tag.title}>
    {tag.label}
  </span>
);

interface U3204MissionModelNotConfiguredTagProps {
  label: string;
}

export const U3204MissionModelNotConfiguredTag: React.FC<U3204MissionModelNotConfiguredTagProps> = ({ label }) => (
  <span
    className={`${tagBaseClass} border border-dashed border-border bg-transparent text-muted-foreground`}
    title={label}
  >
    {label}
  </span>
);
